export default __webpack_public_path__ + "static/media/RosenLynxArt.8808662e.jpeg";